import { hasProperty } from '@/utils';
import { TActionSheetOptions, TActionSheetOptionsGroup } from '@/ui/types';

export const isActionSheetOptionsGroupsGuard = (options: TActionSheetOptions):
  options is TActionSheetOptionsGroup[] => !!options[0] && hasProperty(options[0], 'options');
